import { render, staticRenderFns } from "./Bk.vue?vue&type=template&id=ead55c3a&scoped=true&"
import script from "./Bk.vue?vue&type=script&lang=js&"
export * from "./Bk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ead55c3a",
  null
  
)

export default component.exports